import { useCallback } from 'react';
import useRecurringRules, { RecurringRule } from '@/enterprise/data/useRecurringRules';
import { TakerMarket } from '@/enterprise/data/useTakerMarkets';

const useGetRecurringRulesForTakerMarkets = () => {
  const recurringRules = useRecurringRules();

  const getRecurringRulesForTakerMarkets = useCallback(
    (takerMarkets: TakerMarket[]): RecurringRule[] => {
      return takerMarkets
        .map((takerMarket) => {
          return recurringRules.find(
            ({ rule }) =>
              rule.makerOrganizationUuid === takerMarket.makerOrganizationUuid &&
              rule.takerId === takerMarket.takerDivisionId &&
              rule.marketId === takerMarket.legacyMarketId
          );
        })
        .filter((rule) => !!rule)
        .map(({ rule }) => rule);
    },
    [recurringRules]
  );

  return { getRecurringRulesForTakerMarkets };
};

export default useGetRecurringRulesForTakerMarkets;
